// ==== action types ====

export const SELECT_PRODUCT = 'PRODUCT_SELECTION/SELECT_PRODUCT'
export const SELECTED_PRODUCT = 'PRODUCT_SELECTION/SELECTED_PRODUCT'
export const CHANGE_PRODUCT = 'PRODUCT_SELECTION/CHANGE_PRODUCT'
export const SELECT_PRODUCT_CATEGORY = 'PRODUCT_SELECTION/SELECT_PRODUCT_CATEGORY'
export const AVAILABLE_PRODUCT_CATEGORIES = 'PRODUCT_SELECTION/AVAILABLE_PRODUCT_CATEGORIES'
export const AVAILABLE_PLAN_CODE = 'PRODUCT_SELECTION/AVAILABLE_PLAN_CODE'

export const VALIDATE_INVESTMENT_PRODUCT = 'PRODUCT_SELECTION/VALIDATE_INVESTMENT_PRODUCT'

// ==== action creators ====

export const selectProduct = (product) => ({
  type: SELECT_PRODUCT,
  payload: product,
})

export const selectedProduct = (product) => ({
  type: SELECTED_PRODUCT,
  payload: product,
})

export const changeProduct = (product) => ({
  type: CHANGE_PRODUCT,
  payload: product,
})

export const selectProductCategory = (categoryId) => ({
  type: SELECT_PRODUCT_CATEGORY,
  payload: categoryId,
})
export const availableProductCategories = (categoryIds) => ({
  type: AVAILABLE_PRODUCT_CATEGORIES,
  payload: categoryIds,
})
export const availablePlanCode = (planCodes) => ({
  type: AVAILABLE_PLAN_CODE,
  payload: planCodes,
})

export const validateInvestmentProduct = (product, link) => ({
  type: VALIDATE_INVESTMENT_PRODUCT,
  payload: {
    displayProduct: product,
    link,
  },
})

export const VALIDATE_ORDINARY_PRODUCT = 'PRODUCT_SELECTION/VALIDATE_ORDINARY_PRODUCT'
export const validateOrdinaryProduct = (product, link) => ({
  type: VALIDATE_ORDINARY_PRODUCT,
  payload: {
    displayProduct: product,
    link,
  },
})

export const VALIDATE_NORMAL_PRODUCT = 'PRODUCT_SELECTION/VALIDATE_NORMAL_PRODUCT'
export const validateNormalProduct = (product, link, isSelected) => ({
  type: VALIDATE_NORMAL_PRODUCT,
  payload: {
    displayProduct: product,
    link: link,
    isSelected: isSelected,
  },
})
